import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useMemberAuth } from "@/context/MemberAuthContext";

export default function MemberAuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { completeGoogleLogin, setMember } = useMemberAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const params = new URLSearchParams(location.search);
    const code = params.get("code");
    const state = params.get("state");
    const expectedState = sessionStorage.getItem("google_oauth_state");
    sessionStorage.removeItem("google_oauth_state");
    (async () => {
      try {
        if (!code || !state || state !== expectedState) {
          throw new Error("Invalid or missing Google OAuth state");
        }
        await completeGoogleLogin(code);
      } catch (e) {
        setMember(false);
        toast.error("Google sign-in failed. Please try again.");
      } finally {
        window.history.replaceState(null, "", "/account");
        navigate("/account", { replace: true });
      }
    })();
  }, [location.search, navigate, completeGoogleLogin, setMember]);

  return (
    <div data-testid="member-auth-callback" className="min-h-screen grid place-items-center bg-ptf-bg">
      <p className="text-xs uppercase tracking-[0.28em] text-ptf-text/50 animate-pulse">Signing you in…</p>
    </div>
  );
}
